<template>
  <!-- <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div> -->

  <v-main>
    <router-view />
  </v-main>
  <!-- <v-app>
    <v-main>
      <v-container>
        <v-btn color="primary">Hello World</v-btn>
      </v-container>
    </v-main>
  </v-app> -->
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: "App",
  components: {
    // HelloWorld
  },
  data: () => ({
    //
  }),
  mounted() {
    console.log(this.$vuetify);
  },
};
</script>

